<template>
  <svg
    fill="#000000"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="800px"
    height="800px"
    viewBox="0 0 351.912 351.912"
    xml:space="preserve"
  >
    <g>
      <g>
        <g>
          <path
            d="M342.237,284.604l-54.638-54.668c-4.257-4.245-10.189-6.581-16.693-6.581c-6.845,0-13.462,2.672-18.134,7.338
				l-29.525,29.537l-7.98-4.425c-17.564-9.733-41.599-23.083-66.999-48.507c-25.493-25.473-38.848-49.576-48.621-67.194
				l-4.366-7.758l29.589-29.576c9.791-9.821,10.121-25.439,0.738-34.84L70.961,13.29c-4.254-4.243-10.175-6.591-16.675-6.591
				c-6.854,0-13.459,2.682-18.131,7.359L22.737,27.563l-1.261,2.06C16.489,36.03,12.4,43.229,9.332,51.075
				C6.497,58.553,4.72,65.66,3.915,72.788c-7.046,58.556,19.96,112.317,93.212,185.563c86.835,86.812,159.386,93.561,179.556,93.561
				c3.452,0,5.536-0.186,6.131-0.246c7.451-0.906,14.586-2.69,21.779-5.488c7.77-3.026,14.945-7.086,21.329-12.088l3.057-2.402
				l12.556-12.321C351.31,309.596,351.623,293.996,342.237,284.604z"
          />
        </g>
        <g>
          <path
            d="M198.194,157.593c9.68-0.015,86.907-10.854,89.802-11.286c0.919,0,5.675-0.108,8.095-2.543
				c1.52-1.519,3.272-4.875-2.071-10.22l-19.155-19.149l68.466-68.449c1.67-1.672,3.646-5.996-0.805-10.433L310.406,3.396
				c-2.228-2.225-4.455-3.369-6.653-3.396c-1.675-0.018-3.278,0.64-4.521,1.877c-0.294,0.315-0.522,0.591-0.685,0.805
				l-69.151,69.145l-20.891-20.882c-4.546-4.542-7.548-2.534-8.617-1.444c-2.372,2.366-2.42,7.293-2.372,8.403l-8.448,89.505
				c-0.036,0.456-0.294,4.563,2.426,7.491C192.61,156.128,194.687,157.593,198.194,157.593z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
export default {
  name:"InGoingCall"
}
</script>
